if (window.newrelic?.addRelease) {
  window.newrelic?.addRelease(`web-shell-client`, process.env.WEB_SHELL_CLIENT_VERSION!);
}
